import { render } from "./TransactionsView.vue?vue&type=template&id=5c84ecdc&scoped=true&ts=true"
import script from "./TransactionsView.vue?vue&type=script&lang=ts"
export * from "./TransactionsView.vue?vue&type=script&lang=ts"

import "./TransactionsView.vue?vue&type=style&index=0&id=5c84ecdc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c84ecdc"]])

export default __exports__